/* ============================================================
   THE FLOWER LAB — Elegir la entrega antes de pagar
   ============================================================
   El pedido se arma y sale el mismo día, así que cuándo hay que
   entregarlo condiciona el trabajo del estudio. No es un dato que pueda
   preguntarse después de cobrar: si nadie está en casa esa tarde, o el
   día ya no da tiempo, toca cancelar y devolver.

   Por eso pagar deja de ser el primer paso. Mientras no haya día y franja
   elegidos, el botón queda deshabilitado y los pagos rápidos (Shop Pay y
   compañía) se ocultan: son un atajo que se saltaría la pregunta.

   El paso avisa por su cuenta:
     flowerlab-entrega.js → flowerlab:entrega:cambiada

   Solo se exige si está en pantalla. Apagado desde el customizer, deja de
   pedirse y manda el theme.

   Hasta el 25/08/2026 acá también se exigía el código postal. Se quitó:
   las zonas de reparto ya se comprueban en el checkout de Shopify, con
   las tarifas configuradas en Envíos.

   Dos cosas obligan a re-aplicar el estado en vez de hacerlo una sola vez:
   · el panel del carrito se reemplaza entero al agregar un producto
     (lo hace flowerlab-carrito.js con la Section Rendering API);
   · el theme rehace los botones al recalcular totales.
   De ahí el MutationObserver.
   ============================================================ */
(function () {
  'use strict';

  var BOTONES = '.cart__checkout-button, button[name="checkout"]';
  var CONTENEDOR = '.cart__ctas';
  var ACELERADOS = '.additional-checkout-buttons';
  var CLASE_AVISO = 'flcp-aviso-pago';

  var TEXTO_ENTREGA = 'Elige el día y la hora de entrega.';

  var entregaLista = false;

  function hayEntrega() {
    return !!document.querySelector('[data-fl-entrega]');
  }

  /** El aviso de por qué el botón no responde todavía. */
  function textoPendiente() {
    var raiz = document.querySelector('[data-fl-entrega]');
    return (raiz && raiz.dataset.msgPago) || TEXTO_ENTREGA;
  }

  function crearAviso(contenedor) {
    var aviso = contenedor.querySelector('.' + CLASE_AVISO);
    if (aviso) return aviso;

    aviso = document.createElement('p');
    aviso.className = CLASE_AVISO;
    aviso.setAttribute('role', 'status');
    contenedor.insertBefore(aviso, contenedor.firstChild);
    return aviso;
  }

  function aplicar() {
    // Sin el paso en pantalla no hay nada que exigir: manda el theme.
    if (!hayEntrega()) return;

    var abierto = entregaLista;

    var botones = document.querySelectorAll(BOTONES);
    for (var i = 0; i < botones.length; i++) {
      var boton = botones[i];

      // Con el carrito vacío manda el theme: no se toca.
      if (boton.dataset.flVacio === 'true') continue;

      if (abierto) {
        if (boton.dataset.flBloqueado === 'true') {
          boton.disabled = false;
          delete boton.dataset.flBloqueado;
        }
      } else {
        boton.disabled = true;
        boton.dataset.flBloqueado = 'true';
      }
    }

    var contenedores = document.querySelectorAll(CONTENEDOR);
    for (var j = 0; j < contenedores.length; j++) {
      var caja = contenedores[j];
      caja.dataset.flPago = abierto ? 'abierto' : 'bloqueado';

      var acelerados = caja.querySelector(ACELERADOS);
      if (acelerados) acelerados.hidden = !abierto;

      if (abierto) {
        var viejo = caja.querySelector('.' + CLASE_AVISO);
        if (viejo) viejo.remove();
      } else {
        var aviso = crearAviso(caja);
        aviso.textContent = textoPendiente();
        aviso.dataset.estado = 'pendiente';
      }
    }
  }

  document.addEventListener('flowerlab:entrega:cambiada', function (evento) {
    if (!evento.detail) return;
    entregaLista = !!evento.detail.completa;
    aplicar();
  });

  // El carrito se rehace entero al agregar; hay que volver a aplicarlo.
  var pendiente = false;
  var observador = new MutationObserver(function () {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () {
      pendiente = false;
      aplicar();
    });
  });

  function arrancar() {
    // Se marca cuál venía deshabilitado por el theme (carrito vacío) para
    // no "abrirlo" después por error.
    var botones = document.querySelectorAll(BOTONES);
    for (var i = 0; i < botones.length; i++) {
      if (botones[i].disabled && !botones[i].dataset.flBloqueado) {
        botones[i].dataset.flVacio = 'true';
      }
    }

    // flowerlab-entrega.js se carga ANTES que este archivo y revisa lo que
    // ya había guardado apenas arranca. Ese primer resultado se emitía
    // cuando acá todavía no había nadie escuchando, así que se perdía y el
    // botón seguía cerrado aunque el día ya estuviera elegido. Por eso el
    // resultado también queda anotado: se recoge de ahí.
    var entrega = window.FlowerLabEntrega && window.FlowerLabEntrega.ultimo;
    if (entrega) entregaLista = !!entrega.completa;

    aplicar();
    observador.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
